import debounce from "lodash/debounce";

import type { Track } from "@similarweb/tracking-provider";

import { TRACK_DEBOUNCE_TIMEOUT } from "app/pages/sales-intelligence/constants/timeouts";
import { allTrackers } from "app/services/track/track";

const integrationTrackingService = (track: Track) => {
    return {
        trackStatusConnection(integrationName: string, status: boolean) {
            track(`${integrationName} integration`, "connect", `connect/${status ? "success" : "fail"}`);
        },
        trackDisconnection(integrationName: string) {
            track(`${integrationName} integration`, "disconnect", "disconnect");
        },
        trackConnection(integrationName: string) {
            track(`${integrationName} integration`, "connect", "connect");
        },
        trackManageIntegration(integrationName: string) {
            track(`${integrationName} integration`, "manage integration", `manage/${integrationName}`);
        },
        trackIntegrationApprove(integrationName: string) {
            track(`${integrationName} integration`, "t&c", `approve`);
        },
        trackIntegrationDeny(integrationName: string) {
            track(`${integrationName} integration`, "t&c", `deny`);
        },
        trackDisabledIntegrationModal(integrationName: string, name: string) {
            track(`${integrationName} integration`, "don't show again", `export/${name}`);
        },
        trackMapFieldsModal(integrationName: string) {
            track(`${integrationName} integration`, "map fields", `export/edit mapping/edit mapping`);
        },
        trackAddField(tab: string, field: string, integrationName: string) {
            track(`${integrationName} integration`, "select fields to add", `export/${tab}/${field}`);
        },
        trackAddFields(integrationName: string, tab: string, amountFields: number) {
            track(`${integrationName} integration`, "add fields", `export/${tab}/${amountFields}`);
        },
        trackSearchSWField: debounce((integrationName: string, tab: string, value: string) => {
            track(`${integrationName} integration`, "search field", `export/${tab}/${value}`);
        }, TRACK_DEBOUNCE_TIMEOUT),
        trackOverwriteSWField(integrationName: string, tab: string, toggleStatus: boolean, title: string) {
            track(
                `${integrationName} integration`,
                `${toggleStatus ? "overwrite" : "cancel overwrite"}`,
                `export/${tab}/${title}`,
            );
        },
        trackClickCheckbox({
            integrationName,
            isChecked,
            forEnrichment,
            fieldName,
        }: {
            integrationName: string;
            isChecked: boolean;
            forEnrichment: boolean;
            fieldName: string;
        }) {
            track(
                `${integrationName} integration`,
                `${isChecked ? "add" : "remove"} mapped field`,
                `${isChecked ? "add to" : "remove from"} ${forEnrichment ? "enrichment" : "export"}/${fieldName}`,
            );
        },
        trackMapField(integrationName: string, tab: string, field: string) {
            track(`${integrationName} integration`, `map field`, `export/${tab}/${field}`);
        },
        trackSearchAndAddField(tab: string, field: string, integrationName: string) {
            track(`${integrationName} integration`, "add single field", `export/${tab}/${field}`);
        },
        trackRemoveField(tab: string, field: string, integrationName: string) {
            track(`${integrationName} integration`, "select fields to remove", `export/${tab}/${field}`);
        },
        trackSelectMappingTab(tab: string, integrationName: string) {
            track(`${integrationName} integration`, "select tab", `export/${tab}`);
        },
        trackRequestAccess(integrationName: string) {
            track(`${integrationName} integration`, "request access", `export/request contact access`);
        },
        trackSearch: debounce((tab: string, value: string, integrationName: string) => {
            track(`${integrationName} integration`, "search single field", `export/${tab}/${value}`);
        }, TRACK_DEBOUNCE_TIMEOUT),
        trackSaveChanges(integrationName: string) {
            track(`${integrationName} integration`, "save", "Fields mapping");
        },
        trackDownloadAllowedValuesExcel(integrationName: string, tab: string) {
            track(`${integrationName} integration`, "download excel", `export/${tab}/allowed values`);
        },
        trackNoJobsPopupTriggered(integrationName: string) {
            track(`${integrationName} integration`, "Pop up", "open");
        },
        trackNoJobsPopupSaveClick(integrationName: string) {
            track(`${integrationName} integration`, "Pop up", "click/save");
        },
        trackNoJobsPopupCancelClick(integrationName: string) {
            track(`${integrationName} integration`, "Pop up", "click/cancel");
        },
    };
};

export default integrationTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));
